<template>
  <section class=" mx-auto flex flex-col pt-16 sm:pt-24 lg:pt-32">
    <header class="mb-10">
      <h2 class="text-3xl sm:text-4xl lg:text-5xl text-pretty tracking-tight font-bold font-heading text-primary-800 dark:text-primary-200 text-center">
        Onderzoek
      </h2>
    </header>
    <HomeSectionsInvestigationsItems />
  </section>
</template>
